import { createFederationRef, readonlyFederationRef } from "@constructor/federation-common/base";
function useFederationColorScheme() {
  const colorScheme = createFederationRef("light");
  return {
    colorScheme: readonlyFederationRef(colorScheme),
    setColorScheme
  };
  function setColorScheme(newColorScheme) {
    colorScheme.set(newColorScheme);
  }
}
export {
  useFederationColorScheme as u
};
//# sourceMappingURL=colorScheme.js.map
